import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import api from '../../services/api';

import './styles.css';

import logo from '../../assests/logo-transparent.png';
import fotoAgro from '../../assests/login-hero.png';

export default function Recuperar() {
  const { t } = useTranslation();
  const [email, setEmail] = useState([]);
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const history = useHistory();
  function handleRecuperar(e) {
    e.preventDefault();
    var axios = require('axios');
    var data = { "email": email };
    var config = {
      method: 'post',
      url: BASE_URL + '/v2/users/recover_password',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        alert(t('pages.recover.alert.sendPassword.success'));
        setTimeout(() => {
          history.push("/");
        }, 3000)
      })
      .catch(function (error) {
      });

  }

  return (
    <div className="recuperar-page">
      <section className="recuperar-form-col">
        <div className="recuperar-card">
          <img className="logo" src={logo} alt={t('commons.alt.agroPicture')} />
          <form onSubmit={handleRecuperar}>
            <h1>{t('pages.recover.info')}</h1>
            <p className="recuperar-sub">{t('pages.recover.emailInfo')}</p>
            <label>
              {t('pages.recover.placeholder.email')}
              <input
                type="email"
                placeholder={t('pages.recover.placeholder.email')}
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </label>
            <button className="recuperar-enter" type="submit">{t('pages.recover.buttons.send')}</button>
            <Link className="recuperar-back" to="/">
              <FiArrowLeft size={16} /> {t('pages.recover.buttons.backToLogin')}
            </Link>
          </form>
        </div>
      </section>
      <div className="recuperar-hero">
        <img src={fotoAgro} alt={t('commons.alt.agroPicture')} />
      </div>
    </div>
  )
}
